import NoteEditor from './NoteEditor';

export default NoteEditor;



// WEBPACK FOOTER //
// ./src/components/BookingNote/NoteEditor/index.js